import React, { useRef } from 'react'
import PrivatePageSF from '../../templates/PrivatePageSF.js'
import GenericErrorUI from '../../components/common/GenericErrorUI'
import SpinnerComponentUI from '../../components/common/SpinnerComponentUI'
import './AnalyticsPage.css'

const AnalyticsPageUI = ({ context, messageList, errorList, accountStats, setMyRef, width }) => {
  return (
    <PrivatePageSF context={context} className='pg_f_anl'
      centered={(!accountStats && !errorList)}
    >
      {
        !accountStats && !errorList &&
        <SpinnerComponentUI />
      }
      {
        errorList && errorList.length > 0 &&
        <GenericErrorUI error={errorList[0]} />
      }
      {
        accountStats &&
        <div className="tiles" ref={(element) => setMyRef(element)}>
          <HomePageTileUI label="Orders Booked" linkText="Orders >"
            link="/orders" percent={100} width={width} amount={accountStats.orderTotalF2} />
          <HomePageTileUI label="Budget Set" linkText="Budgets >"
            link="" percent={accountStats.budgetTotal / accountStats.orderTotal * 100}
            width={width} amount={accountStats.budgetTotalF2} />
          <HomePageTileUI label="Invoices Raised" linkText="Invoices >"
            link="" percent={accountStats.invoiceTotal / accountStats.orderTotal * 100}
            width={width} amount={accountStats.invoiceTotalF2} />
          <HomePageTileUI label="Budget Spent" linkText="Expenses >"
            link="" percent={accountStats.budgetSpent / accountStats.orderTotal * 100}
            width={width} amount={accountStats.budgetSpentF2} />
          <HomePageTileUI label="Payments Received" linkText="Payments >"
            link="" percent={accountStats.paymentTotal / accountStats.orderTotal * 100}
            width={width} amount={accountStats.paymentTotalF2} />
          <HomePageTileUI label="Cash Balance" linkText="Cash Flow >"
            link="" percent={0 / accountStats.orderTotal * 100}
            width={width} amount={0} />
        </div>
      }
    </PrivatePageSF>
  );
}

const HomePageTileUI = ({ context, messageList, label, linkText, link, percent, width, amount }) =>
  <div className="tile_sections g_m_top_100">
    <div className="g_flex_h"><LabelAndLinkUI label={label} linkText={linkText} link={link} /></div>
    <div><ProgressBarAndAmountUI percent={percent} width={width} amount={amount} /></div>
  </div>

const LabelAndLinkUI = ({ context, messageList, label, linkText, link }) =>
  <React.Fragment>
    <div className="label">
      {label}
    </div>
    <div className="link">
      <a href={link}>{linkText}</a>
    </div>
  </React.Fragment>

const ProgressBarAndAmountUI = ({ context, messageList, percent, width, amount }) =>
  <div className="progress_bar_and_amount">
    <div className="progress_bar" style={{ width: width * percent / 100 }}></div>
    <div className="amount g_m_left_50">{amount}</div>
  </div>

export default AnalyticsPageUI
